var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGemStarFill = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  d: "M10.654 2.847a1.493 1.493 0 0 1 2.692 0l2.026 4.006c.22.435.621.74 1.086.823l4.278.773c1.206.217 1.685 1.755.832 2.67l-3.026 3.249a1.63 1.63 0 0 0-.415 1.332l.618 4.483c.174 1.264-1.08 2.214-2.178 1.651l-3.895-1.998a1.47 1.47 0 0 0-1.344 0l-3.895 1.998c-1.098.563-2.352-.387-2.178-1.65l.618-4.484a1.63 1.63 0 0 0-.415-1.332L2.432 11.12c-.853-.916-.374-2.454.832-2.671l4.278-.773a1.53 1.53 0 0 0 1.086-.823z"
})));
export default SvgGemStarFill;